export const selectText = (element) => {
  let range;
  if (document.selection) {
    // IE
    range = document.body.createTextRange();
    range.moveToElementText(element);
    range.select();
    document.execCommand('copy');
    range.deselectAll();
  } else if (window.getSelection) {
    range = document.createRange();
    range.selectNode(element);
    window.getSelection().removeAllRanges();
    window.getSelection().addRange(range);
    document.execCommand('copy');
    window.getSelection().removeAllRanges();
  }
};

export const setClipboard = (value) => {
  const tempInput = document.createElement('input');
  tempInput.style = 'position: absolute; left: -1000px; top: -1000px';
  tempInput.value = value;
  document.body.appendChild(tempInput);
  tempInput.select();
  document.execCommand('copy');
  document.body.removeChild(tempInput);
};

export const formatBytes = (bytes, decimals = 0) => {
  if (bytes === 0) return '0 KB';
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${parseFloat((bytes / (k ** i)).toFixed(dm))} ${sizes[i]}`;
};

export const objectFlip = (obj) => {
  const ret = {};
  for (const key in obj) {
    ret[obj[key]] = key;
  }
  return ret;
};

export const parseURL = (url) => {
  const match = url.match(/^(http|https|sftp|ftp|aspera|azure|origin|[\w\+]+)?(?:[\:\/]*)([0-9A-Za-z-`!#$[\]*\\.%_\+~=]+@|[0-9A-Za-z-`!#$[\]*\\.%_\+~=]+:[0-9A-Za-z-`!#$[\]*\\.%_\+~=]+@)?([A-Za-z0-9\.-]*?)(?:\:([0-9]+))?(\/[^?#]*)?(?:\?([^#]*))?(?:#(.*))?$/i);
  const ret = {
    protocol: '',
    login: '',
    password: '',
    host: '',
    port: '',
    path: '',
    query: '',
    fragment: '',
  };
  if (!match) {
    return ret;
  }
  if (match[1]) {
    ret.protocol = match[1];
  }
  if (match[2]) {
    const lp = match[2].split(':');
    if (lp.length === 2) {
      ret.login = lp[0];
      ret.password = lp[1].substr(0, lp[1].length - 1);
    } else {
      ret.login = lp[0].substr(0, lp[0].length - 1);
    }
  }
  if (match[3]) {
    ret.host = match[3];
  }
  if (match[4]) {
    ret.port = match[4];
  }
  if (match[5]) {
    ret.path = match[5];
  }
  if (match[6]) {
    ret.query = match[6];
  }
  if (match[7]) {
    ret.fragment = match[7];
  }
  return ret;
};

export const joinURL = (parsed) => {
  let path = parsed.path.replace(/\/\/+/g, '/');
  path = path === '/' ? '' : path;
  let hostPath = parsed.port ? `${parsed.host}:${parsed.port}${path}` : `${parsed.host}${path}`;
  if (parsed.query || parsed.fragment) {
    hostPath += `?${parsed.query}${parsed.fragment}`;
  }
  hostPath = hostPath.replace(/^\/+/g, '') || '';
  const scheme = parsed.protocol;
  const { login, password } = parsed;
  let lp = '';
  if (login) {
    lp = password ? `${login}:${password}@` : `${login}@`;
  }
  return `${scheme}://${lp}${hostPath}`;
};

// eslint-disable-next-line consistent-return
export const getQueryVariable = (query, variable) => {
  const vars = query.split('&');
  for (let i = 0; i < vars.length; i += 1) {
    const pair = vars[i].split('=');
    // eslint-disable-next-line eqeqeq
    if (decodeURIComponent(pair[0]) == variable) {
      return decodeURIComponent(pair[1]);
    }
  }
};

export const sleep = milliseconds => new Promise(resolve => setTimeout(resolve, milliseconds));
